const {getCountryName, getCountryConstants} = require("./config/countryMapper");

const pwa = require("./config/pwa");
const seo = require("./config/seo");
const apiRegistery = require("./config/apiRegistery");

const throwErrorIfCountryNotAvailable = (country) => {
  if(!country || typeof country !== 'string') throw new Error('Please mention the country name.');
  if(getCountryName(country.toLowerCase()) < 0) throw new Error('No config available with this country');
}

const pwaConfig = {
  getPWAConfig: (country) => {
    throwErrorIfCountryNotAvailable(country);
    return pwa[getCountryName(country.toLowerCase())];
  },
  getCountryConstants: (country) => {
    throwErrorIfCountryNotAvailable(country);
    return getCountryConstants(country.toLowerCase());

  },
  getSeoData: (country) => {
    throwErrorIfCountryNotAvailable(country);
    return seo[getCountryName(country.toLowerCase())];
  },
  getApiRegistery: (country) => {
    throwErrorIfCountryNotAvailable(country);
    return apiRegistery[getCountryName(country.toLowerCase())];
  }
}

module.exports = pwaConfig;